import { InstructionCtrl } from './instruction.controller';

export const InstructionStepComponent = {
  controller: InstructionCtrl,
  bindings: {
    nextStep: '&',
    prevStep: '&',
  },
  template: require('./instruction.html'),
};
